module.exports = __webpack_public_path__ + "img/how-it-works.a5550a20.svg";